export default __webpack_public_path__ + "88a8676c6900f1842dbbd74f6e52f365.png";